import React, { useEffect, useState } from 'react';
import { Input, InputWithSymbol, Multiselect } from '@cokitchen/cokitchen-components';
import { PartnerFormType } from './types';
import { CoKitchenType } from 'models/cokitchen.model';
import { STORAGE_KEYS } from 'utils/constants';

type locationType = {
  text: string;
  value: string;
};

const PartnerFirstStep = ({
  handleChange,
  location,
  setLocation,
  formData
}: {
  handleChange: (e: any) => void;
  location: string[];
  setLocation: (item: string[]) => void;
  formData: PartnerFormType;
}) => {
  const [locations, setLocations] = useState<locationType[]>([]);
  const cokitchenArray: CoKitchenType[] = JSON.parse(
    localStorage.getItem(STORAGE_KEYS.COKITCHEN_LIST) ?? '[]'
  );
  const { partner_name, partner_email, mobile_no, address } = formData;

  const options: locationType[] = [];

  const getLocationOptions = (item: CoKitchenType[]) => {
    for (let i = 0; i < item?.length; i++) {
      if (item)
        options.push({
          value: item[i]?.id,
          text: item[i]?.name
        });
    }
  };

  useEffect(() => {
    getLocationOptions(cokitchenArray);
  }, [cokitchenArray]);

  useEffect(() => {
    if (options) setLocations(options);
  }, []);

  return (
    <div className='space-y-3'>
      <Input
        name='partner_name'
        label='Partner name'
        placeholder='Company name'
        small
        onChange={handleChange}
        value={partner_name}
      />
      <Input
        name='partner_email'
        label='Email'
        placeholder='Company email'
        small
        onChange={handleChange}
        value={partner_email}
      />
      <InputWithSymbol
        type='phone'
        name='mobile_no'
        label='Mobile no.'
        placeholder='+234 0124 422 333'
        small
        onChange={handleChange}
        value={mobile_no}
        symbol='flag'
      />
      <Input
        name='address'
        label='Address'
        placeholder='Company Adress'
        small
        onChange={handleChange}
        value={address}
      />
      <div>
        <label className='font-medium'>Location served</label>
        <Multiselect
          placeholder='Select Location'
          values={location}
          options={locations}
          onChange={setLocation}
        />
      </div>
    </div>
  );
};

export default PartnerFirstStep;
